import { PageEndpoints } from '@/modules/page/page/api/pageEndpoint'

/**
 * Page endpoint instance
 * instantiate Page api class with different api path
 */
export const pageEndpoints = new PageEndpoints()
